import { render, staticRenderFns } from "./SelectSupervisor.vue?vue&type=template&id=74ac1bc2&"
import script from "./SelectSupervisor.vue?vue&type=script&lang=js&"
export * from "./SelectSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports